// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__260ke","fileBtn":"File_fileBtn__2xkfx","closeBtn":"File_closeBtn__1E29n","fileSelected":"File_fileSelected__1WJ6C","disabled":"File_disabled__1ZjQW"};